import { useMutation } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib/axios";
import { RequestDocumentsResponse } from "@/types";

async function createNewDocuments(
  id: string,
  request: FormData
): Promise<RequestDocumentsResponse> {
  const response = await httpRequest.post<RequestDocumentsResponse>(
    `/attachments/finance-entries/${id}`,
    request,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
}

export function useCreateFinanceEntryDocumentsMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, request }: { id: string; request: FormData }) =>
      createNewDocuments(id, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["finance-entry-documents"] });
    },
    onError: () => {},
    ...options,
  });
}
